import NumberFormat from 'react-number-format';

import React from 'react';

import moment from "moment";

const backgroundRed = { background: 'red' };

const Row = ({ params, NaNParams, unixParams, row, id, page }) => {
    let td = getValues(params, NaNParams, unixParams, row, id, page);

    return (
        <tr>{td}</tr>
    );
};

function getValues(params, NaNParams, unixParams, row, id, page) {
    return params.map((param, index) => {
        const value = row[index];

        if (unixParams[param]) return <td key={`${id}:${page}:${param}`}>{moment.unix(value).utc().format('YYYY-MM-DD HH:mm:ss')}</td>
        if (NaNParams[param]) return <td key={`${id}:${page}:${param}`}>{value}</td>

        const styles = value < 0 ? backgroundRed : {};

        if(Array.isArray(value)) {
            const compareValue = getCompareValue(value[1], value[2]);

            return(<td style={styles} key={`${id}:${page}:${param}`}>
                <NumberFormat value={value[0]} displayType={"text"} thousandSeparator={true}/>
                <br/>
                {compareValue}
            </td>);
        }

        return(<td style={styles} key={`${id}:${page}:${param}`}>
            <NumberFormat value={value} displayType={"text"} thousandSeparator={true}/>
        </td>);
    });
}

function getCompareValue(absoluteValue, percentValue) {
    let color;
    const prefix = absoluteValue > 0 ? '+' : '';

    if(absoluteValue > 0) color = 'green';
    if(absoluteValue < 0) color = 'red';
    if(absoluteValue == 0) color = 'grey';

    absoluteValue = <NumberFormat value={absoluteValue} prefix={prefix} displayType={"text"} thousandSeparator={true}/>
    percentValue = <NumberFormat value={percentValue} prefix={prefix} suffix={'%'} displayType={"text"} thousandSeparator={true}/>

    return <span style={{ color }}>{absoluteValue} {percentValue}</span>;
}

export default Row;



// WEBPACK FOOTER //
// ./src/components/StatsTable/components/Table/components/Row/index.js